import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23.768 21.611"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F4ECE0",
  d: "M11.637 0 9.964 9.148 3.813 2.634l-1 .939L8.7 9.9.068 9.589 0 10.936l8.366.377-7.974 5.132.754 1.166L9.334 12.4l-1.823 8.443-.106.491.492.1.359.077.484.1 2.1-9.421 8.39 8.909 1-.958-8.105-8.681 11.091.358.5.016.057-1.361-11.034-.408 7.155-4.952-.78-1.134-7.719 5.263L12.98.22z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "asterix-2"}) } }